<div class="modal-header">
  <h4 class="modal-title" [innerHTML]="options.headerText"></h4>
  @if (options.showCloseButton) {
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  }
</div>
<div class="modal-body" [innerHTML]="options.bodyText"></div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [innerHTML]="options.confirmButtonText"
    (click)="confirm()"
    thAutoFocus
  ></button>
  @if (isConfirmSecondaryModal) {
    <button
      type="button"
      class="btn btn-primary"
      [innerHTML]="options.confirmSecondaryButtonText"
      (click)="confirmSecondary()"
    ></button>
  }
  @if (isConfirmModal || isConfirmSecondaryModal) {
    <button
      type="button"
      class="btn btn-outline-primary"
      [innerHTML]="options.cancelButtonText"
      (click)="cancel()"
    ></button>
  }
</div>
